<div class="card" *ngIf="requests.length > 0">
  <div class="card-header">
    Zulieferer
  </div>
  <div class="card-block">
    <clr-datagrid>

      <clr-dg-column [clrDgField]="'cid'" [clrDgSortOrder]="descSort">Projekte</clr-dg-column>
      <clr-dg-column [clrDgField]="'name_project'">Name</clr-dg-column>

      <clr-dg-placeholder>Kein Projekt gefunden!</clr-dg-placeholder>
      <clr-dg-row *clrDgItems="let request of requests"  [routerLink]="['/project/details', splitProjectNumber(request.project_id, 0), splitProjectNumber(request.project_id, 1)]">
        <clr-dg-cell>{{ request.project_id }} </clr-dg-cell>
        <clr-dg-cell>{{ request.subject }}</clr-dg-cell>
      </clr-dg-row>

      <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="20">
          {{ pagination.firstItem + 1 }} - {{ pagination.lastItem + 1 }}
          von {{ requests.length }} Anfrag(en)
        </clr-dg-pagination>
      </clr-dg-footer>
    </clr-datagrid>
  </div>
</div>
